import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import useStickyAlerts from '@/modules/alerts/composables/useStickyAlerts';
import { StickyAlertPropsSchema } from '@/modules/alerts/models/sticky-alert-props';
import { STICKY_ALERT_TYPE } from '@/modules/alerts/models/sticky-alert-type';

const message = 'Test Alert';


export default /*@__PURE__*/_defineComponent({
  __name: 'WCTestStickyAlert',
  props: {
    id: {}
  },
  setup(__props: any) {

const { findAlert, answerAlert } = useStickyAlerts();

const props = __props;

const alert = findAlert(STICKY_ALERT_TYPE.TEST, props.id);

const close = () => {
  answerAlert(alert, null);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("span", {
      style: {"background-color":"fuchsia"},
      onClick: close
    }, _toDisplayString(message))
  ]))
}
}

})